import React from 'react';
import { Badge, Card, Table } from 'react-bootstrap';

import ActionIconButton from '../../../../components/ActionIconButton';
import { ProjectCostRole } from '../../../../types';
import { useTypedProjectCostContext } from '../../useTypedProjectCostContext';
import TableControls from '../TableControls';
import { formatOptionalCurrencyFromCents } from '../../utils';

type RolesTableProps = {
  companyId?: number;
};

const RolesTable: React.FC<RolesTableProps> = ({ companyId }) => {
  const {
    getPagedRoles,
    handleEditRole,
    handleDelete,
    saving,
  } = useTypedProjectCostContext<{
    getPagedRoles: (companyId?: number | null) => {
      pageItems: ProjectCostRole[];
      totalItems: number;
      totalPages: number;
      currentPage: number;
    };
    handleEditRole: (item: ProjectCostRole) => void;
    handleDelete: (path: string, message: string) => Promise<void>;
    saving: boolean;
  }>();

  const paged = getPagedRoles(companyId ?? null);

  return (
    <Card>
      <Card.Header>Funções</Card.Header>
      <Card.Body className="table-responsive">
        <TableControls
          tableKey="roles"
          placeholder="Buscar por função, descrição ou status..."
          totalItems={paged.totalItems}
          totalPages={paged.totalPages}
          currentPage={paged.currentPage}
        />
        <Table size="sm" hover>
          <thead>
            <tr>
              <th>Função</th>
              <th>Taxa padrão</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {paged.pageItems.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-center text-muted py-3">
                  Nenhum registro encontrado.
                </td>
              </tr>
            ) : (
              paged.pageItems.map((item) => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td>{formatOptionalCurrencyFromCents(item.default_hourly_rate)}</td>
                  <td>
                    <Badge bg={item.is_active ? 'success' : 'secondary'}>
                      {item.is_active ? 'Ativa' : 'Inativa'}
                    </Badge>
                  </td>
                  <td>
                    <div className="d-inline-flex gap-1">
                      <ActionIconButton
                        icon="✏️"
                        label={`Editar função ${item.name}`}
                        variant="outline-primary"
                        onClick={() => handleEditRole(item)}
                        disabled={saving}
                      />
                      <ActionIconButton
                        icon="🗑️"
                        label={`Excluir função ${item.name}`}
                        variant="outline-danger"
                        onClick={() => void handleDelete(
                          `/api/projects/costs/roles/${item.id}`,
                          `Excluir função "${item.name}"?`,
                        )}
                        disabled={saving}
                      />
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default RolesTable;
